import React from 'react';
import styled from 'styled-components';
import { gray9 } from '../../shared/colours';
import { header700 } from '../../shared/typography';

const Container = styled.span`
  ${header700};
  color: ${gray9};
`;

interface Props {
  text: string,
}

const HeaderTextAtom = ({ text }: Props) => (
  <Container>
    {text}
  </Container>
);

export default HeaderTextAtom;
